import React__default from 'react';
import classNames from 'classnames';
import Styles from './Spinner.module.scss.js';

const Spinner = ({ customStyles }) => {
    return (React__default.createElement("div", { className: Styles.loader },
        React__default.createElement("div", { className: classNames("spinner-border", customStyles), role: "status" },
            React__default.createElement("span", { className: "sr-only" }, "Loading..."))));
};

export { Spinner as default };
//# sourceMappingURL=Spinner.js.map
